import { BookOutlined, CheckOutlined, ClockCircleOutlined, ExclamationCircleOutlined, HomeOutlined, ProfileOutlined, SafetyOutlined, SelectOutlined, SettingOutlined, SnippetsOutlined, SyncOutlined, UserOutlined, WarningOutlined } from '@ant-design/icons';
import { dateFormat, dateFormatIso, menuLinks, notifyMessages, orderUploadStatus } from './constants';
import dayjs from 'dayjs';
import { Col, Form, Input, InputNumber, message, Row, Tag } from 'antd';
import CommonServices from '../services/commonServices';
import ReactCountryFlag from "react-country-flag";

export const generateMenuIcon = (menuName) => {
    let icon = null;
    switch (menuName) {
        case menuLinks.dashboard:
            icon = <HomeOutlined />;
            break;
        case menuLinks.customerOrders:
            icon = <ProfileOutlined />;
            break;
        case menuLinks.creditNote:
            icon = <SnippetsOutlined />;
            break;
        case menuLinks.importLogs:
            icon = <BookOutlined />;
            break;
        case menuLinks.configs:
            icon = <SettingOutlined />;
            break;
        case menuLinks.users:
            icon = <UserOutlined />;
            break;
        case menuLinks.roles:
            icon = <SafetyOutlined />;
            break;
        default:
            icon = <SelectOutlined />;
    }
    return icon;
}

export const handleDateConvertDayJs = (date) => {
    if (date) {
        let formatedDate = dayjs(date).format(dateFormat);
        return formatedDate
    }
    return null
};

export const handleDateConvertForApis = (date) => {
    if (date) {
        let formatedDate = dayjs(date).format(dateFormatIso);
        return formatedDate
    }
    return null
};

export const changeApplication = async (payload) => {
    try {
        const respData = await CommonServices.setSelectedApplication(payload);
        if (respData.success) {
            message.success(notifyMessages.success);
            // window.location.replace("/");
        }
        else {
            message.error(notifyMessages.errorAccured);
        }
    } catch (error) {
        message.error(notifyMessages.errorAccured);
    }
}



export const orderUploadStatusComp = (orderStatus, t) => {
    let status;
    if (orderStatus === orderUploadStatus.inProgress) {
        status = (<Tag color={"geekblue"} icon={<SyncOutlined spin />}> {t('general.inProgressStatus')}</Tag>)
    }
    if (orderStatus === orderUploadStatus.success) {
        status = (<Tag icon={<CheckOutlined />} color={"green"}>{t('general.successStatus')}</Tag>)
    }
    if (orderStatus === orderUploadStatus.failed) {
        status = (<Tag icon={<ExclamationCircleOutlined />} color={"volcano"}>{t('general.failedStatus')}</Tag>)
    }
    if (orderStatus === orderUploadStatus.pending) {
        status = (<Tag style={{ color: "#000000", background: "#e7e7e7" }} icon={<ClockCircleOutlined />} color={"#default"}>{t('general.pendingStatus')}</Tag>)
    }
    if (orderStatus === orderUploadStatus.partiallyProcessed) {
        status = (<Tag icon={<WarningOutlined  />} color={"gold"}>{t('general.warningStatus')}</Tag>)
    }
    if (orderStatus === orderUploadStatus.completed) {
        status = (<Tag icon={<CheckOutlined />} color={"green"}>{t('general.completedStatus')}</Tag>)
    }
    return status;
}

export const rederOrderItemConditionsFields = (initValues, location, t) => {

    const elements = [];
    for (let i = 1; i <= 7; i++) {
        elements.push(
            <Row gutter={16} key={i}>
                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 9 }} lg={{ span: 9 }}>
                    <Form.Item
                        label={`${t('order.conditionType')} ${i}`}
                        name={`conditionType${i}`}
                        initialValue={location === "update" ? initValues[`conditionType${i}`] : ""}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 9 }} lg={{ span: 9 }}>
                    <Form.Item
                        label={`${t('order.conditionValue')} ${i}`}
                        name={`conditionValue${i}`}
                        initialValue={location === "update" ? initValues[`conditionValue${i}`] : ""}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }}>
                    <Form.Item
                        label={`${t('order.amount')} ${i}`}
                        name={`amount${i}`}
                        initialValue={location === "update" ? initValues[`amount${i}`] : ""}
                    >
                        <InputNumber min={0} precision={0} style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
            </Row>
        )
    }
    return elements;
}

export const errorAlertDisplay = (response) => {
    if (response && response.errorDetail) {
        return message.error(response.errorDetail.errorMessage);
    }
    else {
        return message.error(notifyMessages.errorAccured);
    }
}


export const getCountryLabel = (country) => {
    return ( <div><ReactCountryFlag countryCode={country.code} svg /> - {country.description}</div>);
}